import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';

import { environment } from '@dps/env';
import {
  CalculatedTransportationDistanceModel,
  EmployeeWageModel,
  MinimumWageModel,
  PageableResponsePayloadModel,
} from '@dps/shared/models';
import {
  EmployeeWagesListRequestParamsModel,
  MinimumWageParamsModel,
  TransportParamsModel,
} from './employee-wages-list-request-params.model';
import { BaseApi } from '../models/base-api';

@Injectable({
  providedIn: 'root',
})
export class EmployeeWageApiService extends BaseApi {
  private http = inject(HttpClient);

  readonly EMPLOYEE_WAGES_API_URL = `${environment.apiBaseUrl}/employeewages`;
  readonly EMPLOYEE_API_URL = `${environment.apiBaseUrl}`;

  createWage(wage: EmployeeWageModel): Observable<EmployeeWageModel> {
    return this.http.post<EmployeeWageModel>(this.EMPLOYEE_WAGES_API_URL, wage);
  }

  updateWage(wageId: string, wage: EmployeeWageModel): Observable<EmployeeWageModel> {
    return this.http.put<EmployeeWageModel>(`${this.EMPLOYEE_WAGES_API_URL}/${wageId}`, wage);
  }

  removeWage(wageId: string): Observable<void> {
    return this.http.delete<void>(`${this.EMPLOYEE_WAGES_API_URL}/${wageId}`);
  }

  getEmployeeWages(
    params: EmployeeWagesListRequestParamsModel
  ): Observable<Array<EmployeeWageModel>> {
    return this.http
      .get<PageableResponsePayloadModel<EmployeeWageModel>>(this.EMPLOYEE_WAGES_API_URL, {
        params: this.mapParamsToString(params),
      })
      .pipe(map(resp => resp.content));
  }

  getMinimumWage(params: MinimumWageParamsModel): Observable<MinimumWageModel> {
    return this.http.get<MinimumWageModel>(`${this.EMPLOYEE_WAGES_API_URL}/minimum-wage`, {
      params: this.mapParamsToString(params),
    });
  }

  getTravelAllowance(
    params: TransportParamsModel
  ): Observable<CalculatedTransportationDistanceModel> {
    return this.http.get<CalculatedTransportationDistanceModel>(
      `${this.EMPLOYEE_API_URL}/travelallowance/calculate`,
      {
        params: this.mapParamsToString(params),
      }
    );
  }
}
